var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetStartedLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 33.0002C6 35.5202 5 43.0002 5 43.0002C5 43.0002 12.48 42.0002 15 39.0002C16.42 37.3202 16.4 34.7402 14.82 33.1802C14.0426 32.4382 13.0186 32.0094 11.9445 31.9762C10.8703 31.943 9.82175 32.3076 9 33.0002Z",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30L18 24C19.0643 21.2389 20.4044 18.5921 22 16.1C24.3304 12.374 27.5752 9.30611 31.426 7.18819C35.2768 5.07028 39.6053 3.97275 44 4.00001C44 9.44001 42.44 19 32 26C29.4738 27.5975 26.7937 28.9375 24 30Z",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24H8C8 24 9.1 17.94 12 16C15.24 13.84 22 16 22 16",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30V40C24 40 30.06 38.9 32 36C34.16 32.76 32 26 32 26",
    stroke: "#736F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedLink);
export default __webpack_public_path__ + "static/media/get-started-link.0d7c5532ddf0980cda362382158656db.svg";
export { ForwardRef as ReactComponent };